import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import useRequest from "~/common/hooks/useRequest";
import InviteModal from "./InviteModal";
import ExcelLoader from "~/common/components/Excel";
import { API_STATE } from "~/common/constants/state";
import { convertDateFormat } from "~/utils/validation";


const AddMemberModal = ({
    inviteModal,
    setInviteModal,
    authMemberListRequest,
    teamInviteRequest
}) => {
    const [excelData, setExcelData] = useState([]);
    const [modalWidth, setModalWidth] = useState(700);
    const [error, setError] = useState("");
    // const teamInviteRequest = useRequest("get", `admin/invite?size=100&page=1`);
    // const teamInviteRequest = useRequest("get", "admin/auth/member");
    const uploadFileRequest = useRequest("post", "/admin/inviteMember/uploadFile");

    useEffect(() => {
        !inviteModal && setError("")
    }, [inviteModal])

    const handleUpload = (data) => {
        let englishArray = data.map(item => ({
            // 다음 항목들이 모두 존재하는지 발리데이션,joinDate,workStartDay 포멧 검사 연도 통일 
            name: item["이름"],
            email: item["이메일"],
            joinDate: item["입사일"],
            workStartDay: item["근무시작일"], // YYYY-MM-DD 포맷만 추출
            numOfRemainAnnualLeave: item["남은연차수"]
        }));

        englishArray = englishArray.filter(ele => ele.name !== '예시) 홍길동')
        englishArray = englishArray.map(ele => ({
            ...ele,
            joinDate: convertDateFormat(String(ele.joinDate)),
            workStartDay: convertDateFormat(String(ele.workStartDay)),
            numOfRemainAnnualLeave: Number(ele.numOfRemainAnnualLeave)
        }))

        if (englishArray.some(ele => ele.joinDate === false || ele.workStartDay === false)) {
            setError('엑셀 기본 양식 예시를 참고하여 수정 후 다시 업로드해 주세요.')
        }
        else {
            setExcelData(englishArray)
            setError("")
        }
    }

    useEffect(() => {
        switch (uploadFileRequest.state) {
            case API_STATE.done:
                const responseData = uploadFileRequest.response.data;
                console.log('responseData', responseData)
                // setImg(responseData);
                // setStatus("done");
                break;
            case API_STATE.loading:
                // setStatus("loading");
                break;
            case API_STATE.error:
                // setStatus("error");
                console.log("error", uploadFileRequest.error);
                break;
            default:
                break;
        }
    }, [uploadFileRequest.state, uploadFileRequest.response, uploadFileRequest.error]);

    const inviteModalHeader = (
        <div //className="team-add-modal-header-wrapper"
        >
            <div className="team-add-modal-header-wrapper">
                <h3>팀원 정보입력</h3>
                <ExcelLoader
                    downLoadFormat={[
                        {
                            이름: "예시) 홍길동",
                            이메일: "hong@gitbal.com",
                            입사일: '2024-01-01',
                            근무시작일: '2024-01-01',
                            남은연차수: "14"
                        }
                    ]}

                    name={`팀원초대_기본양식`}
                    onAction={handleUpload}
                />
            </div>
            <div className="team-add-modal-sub-wrapper">
                <h4>초대할 팀원의 이름, 이메일을 입력해 주세요.</h4>
                <p>비밀번호는 자동으로 부여됩니다. 메일 재전송이 필요할 경우 팀원 목록 우측에 있는 버튼을 클릭해 주세요.</p>
            </div>
        </div>
    )

    return (
        <ModalTemplate
            modalState={inviteModal}
            setModalToggle={setInviteModal}
            width={modalWidth}
            height={490}
            className={"modal-team-invite"}
            title={'팀원 초대'}
        >

            <InviteModal
                children={inviteModalHeader}
                teamInviteRequest={teamInviteRequest}
                setModalWidth={setModalWidth}
                authMemberListRequest={authMemberListRequest}
                excelData={excelData}
                setExcelData={setExcelData}
                error={error}
            />

        </ModalTemplate>
    );
};
export default AddMemberModal;
